import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  openModal: `${NAMESPACE}_ROUTE_DIVISION_OPEN_MODAL`,
  closeModal: `${NAMESPACE}_ROUTE_DIVISION_CLOSE_MODAL`,
  openForm: `${NAMESPACE}_ROUTE_DIVISION_OPEN_FORM`,
  backToForm: `${NAMESPACE}_ROUTE_DIVISION_BACK_TO_FORM`,
  closeForm: `${NAMESPACE}_ROUTE_DIVISION_CLOSE_FORM`,
  splitRoute: `${NAMESPACE}_ROUTE_DIVISION_SPLIT_ROUTE`,
  splitRouteSuccess: `${NAMESPACE}_ROUTE_DIVISION_SPLIT_ROUTE_SUCCESS`,
  routeValidate: `${NAMESPACE}_ROUTE_DIVISION_SPLIT_ROUTE_VALIDATE`,
  toggleLoading: `${NAMESPACE}_ROUTE_DIVISION_SPLIT_ROUTE_TOGGLELOADING`,
  routeValidateSuccess: `${NAMESPACE}_ROUTE_DIVISION_ROUTE_VALIDATE_SUCCESS`,
  routeValidateError: `${NAMESPACE}_ROUTE_DIVISION_ROUTE_VALIDATE_ERROR`
};

export const actionCreators = {
  openModal: () => ({ type: actions.openModal }),
  closeModal: () => ({ type: actions.closeModal }),
  openForm: () => ({ type: actions.openForm }),
  backToForm: () => ({ type: actions.backToForm }),
  closeForm: () => ({ type: actions.closeForm }),
  splitRoute: () => ({ type: actions.splitRoute }),
  splitRouteSuccess: () => ({ type: actions.splitRouteSuccess }),
  routeValidate: (payload) => ({ type: actions.routeValidate, payload }),
  routeValidateSuccess: (payload) => ({ type: actions.routeValidateSuccess, payload }),
  routeValidateError: (payload) => ({ type: actions.routeValidateError, payload }),
  toggleLoading: (payload) => ({ type: actions.toggleLoading, payload })
};

export default {
  actions,
  actionCreators
};
